import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker, TimePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  updateDoc,
  increment,
  addDoc,
  setDoc,
} from "firebase/firestore";
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import PropTypes from 'prop-types';
import * as dev_constants from '../../constants/dev_constants';
import ToggleOffTwoToneIcon from '@mui/icons-material/ToggleOffTwoTone';
import ToggleOnTwoToneIcon from '@mui/icons-material/ToggleOnTwoTone';
import Signal0 from "../../assets/images/signal-0.svg";
import Signal1 from "../../assets/images/signal-1.svg";
import Signal2 from "../../assets/images/signal-2.svg";
import Signal3 from "../../assets/images/signal-3.svg";
import Signal4 from "../../assets/images/signal-4.svg";
import { deviceStatusCode, deviceModeCode, deviceErrorEventCode, deviceErrorEventCodeOrder } from "../../constants/constants";
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, timeConvertUtility } from "../../utilities/utility";
import { checkUserAccess, db, getCheckSession, getUserName, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import DeviceDataService from "../../apis/device-data"
import { Pagination, TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Backdrop, Box, Checkbox, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography, useMediaQuery } from "@material-ui/core";
import LampLiveFeed from './LampLiveFeed'
import LampDataService from "../../apis/lamps-data";
import { KeyboardArrowLeft, KeyboardArrowRight, Search } from "@material-ui/icons";
import PoleDataService from "../../apis/pole-data";
import { updateSlcData } from "../../query/device.query";
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import { FiDownload } from "react-icons/fi";
import jsPDF from "jspdf";
import * as XLSX from 'xlsx';
import autoTable from "jspdf-autotable";
import FileSaver from "file-saver";
import { getPoleBySlcId } from "../../query/pole.query";
import SlcMap from "./SlcMap";
import { getSchedule, getScheduleHistoryAPICall, getScheduleInfo, updateDimScheduleFromPopup, updateFlag } from "../../query/dim-schedule.query";
import HistoryIcon from '@mui/icons-material/History';
import EditIcon from '@mui/icons-material/Edit';
import { isEqual } from "date-fns";
import { NotificationManager } from "react-notifications";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Schedule } from "./LiveMeterSch";
import { createDimScheduleHistory } from "../../query/dim-schedule-history.query";

// ─── Screen-local mount guard ─────────────────────────────────────────────────
let _liveMeterMounted = false;
// ─────────────────────────────────────────────────────────────────────────────

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: theme.palette.grey[500],
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    tab: {
      '& .MuiTabPanel-root': {
        padding: '0px',
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      opacity: 0.5,
    },
  })
);

const LiveMeterFeed = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = React.useRef();
  const [isAPILoading, setIsAPILoading] = useState(false);

  // "1" = SLC tab, "2" = ILM tab
  const [activeTab, setActiveTab] = useState('1');

  const localFilter = React.useRef({
    zone: 0,
    ward: 0,
    slcCcms: 0,
    ilmCcms: 0,
    status: 0,
  });

  const [pendingFilter, setPendingFilter] = useState({
    zone: 0,
    ward: 0,
    slcCcms: 0,
    ilmCcms: 0,
    status: 0,
  });

  const [slcCcmsFilterList, setSlcCcmsFilterList] = useState([]);
  const [ilmCcmsFilterList, setIlmCcmsFilterList] = useState([]);

  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0,
    status: 0,
  });
  const [applyedFilterObj, setApplyedFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0
  });
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [ccmsFilterList, setCcmsFilterList] = useState([]);
  const [statusFilterList, setStatusFilterList] = useState([
    { label: "All", value: 0 },
    { label: "ON", value: 1 },
    { label: "OFF", value: 2 },
  ]);

  const [selectedStartTimeDate, setSelectedStartTimeDate] = useState(new Date());
  const [scheduleTime, setScheduleTime] = useState("");
  const [selectedEndTimeDate, setSelectedEndTimeDate] = useState(new Date());
  const [editScheduledTime, setEditScheduledTime] = useState("");

  const handleChangeSLCSchedulDate = (date, type) => {
    if (type === "start") {
      setSelectedStartTimeDate(date);
    } else {
      setSelectedEndTimeDate(date);
    }
  };

  const handleSLCSchedulSave = async () => { };

  const [enableStatus, setEnableStatus] = useState(false);

  const handleOnClick = (value, data) => {
    setIsAPILoading(true);
    updateSlcData(slcDialog.docId, value, data).then(() => {
      setSlcDialog((prevState) => ({
        ...prevState,
        [value]: data
      }));
    }).finally(() => {
      setIsAPILoading(false)
    });
  }

  const getDefaultScheduleHistoryAPICall = async () => {
    let historyList = [];
    const q = query(
      collection(db(), "schedule_history"),
      where("name", "==", "default"),
      orderBy("ch_dt", "desc")
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const record = doc.data();
      historyList = [...historyList, record];
    });
    historyList = historyList.map((historyItem) => {
      const { user: lastModifiedBy, ch_dt: { seconds } = {} } =
        historyItem || {};
      const { onTime, offTime } = timeConvertUtility(historyItem);
      return {
        onTime,
        offTime,
        lastModifiedBy,
        lastModifiedDate: format(new Date(seconds * 1000), "MM/dd/yyyy"),
      };
    });
    setDefaultScheduleHistoryData(historyList);
    setScheduleHistoryOpen(true)
  };

  const scheduleTimeSet = (editScheduledTime) => {
    const { off_time, on_time } = editScheduledTime;
    const currentDate = new Date();
    const startTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      on_time.hrs,
      on_time.mins
    );
    const endTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      off_time.hrs,
      off_time.mins
    );
    setSelectedStartTimeDate(startTimeDate);
    setSelectedEndTimeDate(endTimeDate);
  }

  useEffect(() => {
    if (editScheduledTime) {
      scheduleTimeSet(editScheduledTime)
    }
  }, [editScheduledTime]);

  const [editDialog, setEditDialog] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [scheduleDocId, setScheduleDocId] = useState(null);
  const [defaultDocId, setDefaultDocId] = useState(null);

  const [page, setPage] = useState(DeviceDataService.getInstance().getPageIndex());
  const [pageSize, setPageSize] = useState(DeviceDataService.getInstance().getPageSize());
  const [masterCcmsFilterList, setMasterCcmsFilterList] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [dashboardReportRawData, setDashboardReportRawData] = useState([]);
  const [opReportDataPaged, setOpReportDataPaged] = useState([]);
  const [opReportData, setOpReportData] = useState([]);
  const [opTotalReportData, setTotalOpReportData] = useState([]);
  const [totalRows, setTotalRows] = useState([]);
  const [lampReportData, setLampReportData] = useState([]);
  const [lampReportDataPaged, setLampReportDataPaged] = useState([]);

  // ─── FIX: Separate lamp page index and total records ─────────────────────
  // lampPage = current page number (for LampLiveFeed pagination controls)
  // lampTotalRecords = total number of ILM records (for page count calculation)
  const [lampPage, setLampPage] = useState(1);
  const [lampTotalRecords, setLampTotalRecords] = useState(0);
  // ─────────────────────────────────────────────────────────────────────────

  const fetchIlmUidList = async (zoneId, wardId) => {
    try {
      const { deviceListIds = [{ label: "All", value: 0 }] } =
        await LampDataService.getInstance().getPagedLampsByFilter(
          zoneId,
          wardId,
          0,
          0,
          1,
          9999
        );
      setIlmCcmsFilterList(deviceListIds);
    } catch (e) {
      console.error("fetchIlmUidList error", e);
      setIlmCcmsFilterList([{ label: "All", value: 0 }]);
    }
  };

  useEffect(async () => {
    _liveMeterMounted = true;
    console.log("========== LiveMeterFeed : OnInit() ==========");

    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }

    await DeviceAddressService.getInstance().getAllAddressAPICall();
    await PoleDataService.initService();

    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);

    const initZone = zoneList[0].value;
    const initWard = wardList[0].value;

    localFilter.current = {
      ...localFilter.current,
      zone: initZone,
      ward: initWard,
    };
    setPendingFilter((prev) => ({
      ...prev,
      zone: initZone,
      ward: initWard,
    }));

    setFilterObj((prevState) => ({
      ...prevState,
      zone: initZone,
      ward: initWard,
    }));

    await DeviceDataService.getInstance().setDeviceFilter(initZone, initWard, 0);
    DeviceDataService.getInstance().setPageIndex(page);
    DeviceDataService.getInstance().setPageSize(pageSize);
    DeviceDataService.getInstance().initService(onFetchComplete, iterateDeviceHandler);

    // ─── FIX: Init LampDataService with page 1 ────────────────────────────
    LampDataService.getInstance().setPageIndex(1);
    // ─────────────────────────────────────────────────────────────────────
    LampDataService.getInstance().initService(onLampFetchComplete, iterateLampDeviceHandler);

    await fetchIlmUidList(initZone, initWard);

    return () => {
      _liveMeterMounted = false;
    };
  }, []);

  const [slcDialog, setSlcDialog] = useState(null);
  const [scheduleHistoryOpen, setScheduleHistoryOpen] = useState(null);
  const [lampCount, setLampCount] = useState('N/A');
  const [ILMCount, setILMCount] = useState('N/A');

  const [historyDialog, setHistoryDialog] = useState(false);
  const [dimScheduleDialog, setDimScheduleDialog] = useState({ view: '', start: new Date(), end: new Date() });
  const [onUpdateDimSchedule, setOnUpdateDimSchedule] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [scheduleDataID, setScheduleDataID] = useState(false);

  const scheduleDialogClose = async () => {
    setScheduleData([])
    setHistoryDialog(false);
  }

  const OnClickAddSchedule = async () => {
    if (scheduleData.slot_times === undefined | null) {
      scheduleData["slot_times"] = [];
    }
    if (scheduleData.slot_times?.length < 5) {
      setDimScheduleDialog({ view: 'add', start: new Date(), end: new Date(), dp: 0 });
    } else {
      NotificationManager.error("Maximum dim schedile added.", "", 3000);
    }
  }

  const OnClickEditSchedule = async (rowData) => {
    const { off_time, on_time, } = rowData;
    const currentDate = new Date();
    const startTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      on_time.hrs,
      on_time.mins
    );
    const endTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      off_time.hrs,
      off_time.mins
    );
    setDimScheduleDialog({ view: 'edit', data: rowData, start: startTimeDate, end: endTimeDate });
  }

  const OnClickDeleteSchedule = async (rowData) => {
    if (scheduleData.slot_times.length > 1) {
      let index = rowData["tableData"]["id"];
      let { slot_times, ver = 0 } = scheduleData;
      slot_times.splice(index, 1);
      setScheduleData((prevState) => ({
        ...prevState,
        slot_times: slot_times,
        ver: ver + 1,
      }));
      setOnUpdateDimSchedule(true);
    } else {
      NotificationManager.error("Failed to delete Schedule", "", 3000);
    }
  }

  const OnClickCancelDimSchedule = async () => {
    setDimScheduleDialog({ view: '' });
  }

  const handleSelectedDate = (date, type) => {
    if (type === "dim-start") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        start: date
      }));
    } else if (type === "dim-end") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        end: date
      }));
    }
  };

  const OnClickUpdateDimSchedule = async () => {
    let { slot_times, ver = 0 } = scheduleData;
    let { dp } = dimScheduleDialog;
    if (parseInt(dp) === NaN) {
      NotificationManager.error("Please enter valid dim percentage", "", 3000);
      return;
    }
    if (dimScheduleDialog.view === 'add') {
      slot_times.push({
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
      });
    } else {
      let index = dimScheduleDialog.data["tableData"]["id"];
      slot_times[index] = {
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
      }
    }
    setScheduleData((prevState) => ({
      ...prevState,
      slot_times: slot_times,
    }));
    setOnUpdateDimSchedule(true);
    setDimScheduleDialog({ view: '', start: new Date(), end: new Date() });
  }

  const hideSlcInfoDialog = () => {
    setSelectedStartTimeDate(new Date())
    setSelectedEndTimeDate(new Date())
    setScheduleTime("")
    setDefaultDocId(null)
    setScheduleDocId(null)
    setEditScheduledTime('')
    setSlcDialog(null);
    setLampCount("N/A")
    setILMCount("N/A")
    setEnableStatus(false);
  }

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);

    if (name === "zone") {
      const wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      const initWard = wardList[0].value;

      localFilter.current = {
        ...localFilter.current,
        zone: value,
        ward: initWard,
        slcCcms: 0,
        ilmCcms: 0,
      };
      setPendingFilter((prev) => ({
        ...prev,
        zone: value,
        ward: initWard,
        slcCcms: 0,
        ilmCcms: 0,
      }));
      setFilterObj((prev) => ({ ...prev, zone: value, ward: initWard, ccms: 0 }));

      const { deviceListIds = [] } = await DeviceDataService.getInstance()
        .getDevicesByUidFilter(value, initWard);
      setSlcCcmsFilterList(deviceListIds);
      setCcmsFilterList(deviceListIds);

      await fetchIlmUidList(value, initWard);

    } else if (name === "ward") {
      const { zone: currentZone } = localFilter.current;

      localFilter.current = {
        ...localFilter.current,
        ward: value,
        slcCcms: 0,
        ilmCcms: 0,
      };
      setPendingFilter((prev) => ({
        ...prev,
        ward: value,
        slcCcms: 0,
        ilmCcms: 0,
      }));
      setFilterObj((prev) => ({ ...prev, ward: value, ccms: 0 }));

      const { deviceListIds = [] } = await DeviceDataService.getInstance()
        .getDevicesByUidFilter(currentZone, value);
      setSlcCcmsFilterList(deviceListIds);
      setCcmsFilterList(deviceListIds);

      await fetchIlmUidList(currentZone, value);

    } else if (name === "ccms") {
      if (activeTab === '1') {
        localFilter.current = { ...localFilter.current, slcCcms: value };
        setPendingFilter((prev) => ({ ...prev, slcCcms: value }));
      } else {
        localFilter.current = { ...localFilter.current, ilmCcms: value };
        setPendingFilter((prev) => ({ ...prev, ilmCcms: value }));
      }
      setFilterObj((prev) => ({ ...prev, ccms: value }));

    } else {
      localFilter.current = { ...localFilter.current, status: value };
      setPendingFilter((prev) => ({ ...prev, status: value }));
      setFilterObj((prev) => ({ ...prev, status: value }));
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    setPage(1);
    DeviceDataService.getInstance().setPageIndex(1);
    // ─── FIX: Reset lamp page on tab change ──────────────────────────────
    setLampPage(1);
    LampDataService.getInstance().setPageIndex(1);
    // ─────────────────────────────────────────────────────────────────────

    if (newValue === '2') {
      localFilter.current = {
        ...localFilter.current,
        slcCcms: 0,
        ilmCcms: 0,
        status: 0
      };
      setPendingFilter((prev) => ({
        ...prev,
        slcCcms: 0,
        ilmCcms: 0,
        status: 0
      }));

      setFilterObj((prev) => ({
        ...prev,
        zone: localFilter.current.zone,
        ward: localFilter.current.ward,
        ccms: 0,
        status: 0
      }));

      fetchIlmUidList(localFilter.current.zone, localFilter.current.ward);

    } else {
      localFilter.current = {
        ...localFilter.current,
        ilmCcms: 0,
        slcCcms: 0,
        status: 0
      };
      setPendingFilter((prev) => ({
        ...prev,
        ilmCcms: 0,
        slcCcms: 0,
        status: 0
      }));

      setFilterObj((prev) => ({
        ...prev,
        zone: localFilter.current.zone,
        ward: localFilter.current.ward,
        ccms: 0,
        status: 0
      }));

      DeviceDataService.getInstance()
        .getDeviceUidListByZoneWard(localFilter.current.zone, localFilter.current.ward)
        .then((deviceListIds) => {
          setSlcCcmsFilterList(deviceListIds);
          setCcmsFilterList(deviceListIds);
        });
    }
  };

  const [scheduleHistoryData, setScheduleHistoryData] = useState([]);

  const getScheduleHistoryColumnList = () => {
    return [
      { title: "Name", field: "name" },
      { title: "Enabled", field: "enabled" },
      {
        title: "Schedule",
        field: "scList",
        render: rowData => (
          <div>
            {rowData.scList?.map(item => item.replace(/,\s*$/, "")).map((text, index) => (
              <div key={index}>{text}</div>
            ))}
          </div>
        ),
        cellStyle: { whiteSpace: 'nowrap' },
      },
      { title: "Modified By", field: "lastModifiedBy" },
      { title: "Date", field: "lastModifiedDate" },
    ];
  };

  const [defaultScheduleHistoryData, setDefaultScheduleHistoryData] = useState([]);
  const getDefaultScheduleHistoryColumnList = () => {
    return [
      { title: "Start Time", field: "onTime" },
      { title: "End Time", field: "offTime" },
      { title: "Modified By", field: "lastModifiedBy" },
      { title: "Date", field: "lastModifiedDate" },
    ];
  };

  const getUserNameEmail = (propName) => {
    let configResponse = localStorage.getItem("firebaseConfigApiResponse");
    let detail = "";
    if (configResponse) {
      configResponse = JSON.parse(configResponse);
      switch (propName) {
        case "email":
        default: {
          detail = localStorage.getItem("userEmail") || "";
          break;
        }
      }
    }
    return detail;
  };

  const OnClickSaveSchedule = async () => {
    if (slcDialog?.dev_id != null && slcDialog?.dev_id != undefined) {
      if (scheduleData.slot_times.length >= 1) {
        scheduleData.slot_times = scheduleData.slot_times.map(({ tableData, ...rest }) => rest);
        const user = getUserNameEmail('email');
        let updatedVersion = 1;
        const newDocRef = doc(collection(db(), "schedules"), slcDialog.dev_id);
        let docRef = doc(db(), "schedules", slcDialog.dev_id);
        const docSnapshot = await getDoc(docRef);
        if (!docSnapshot.empty && docSnapshot.data()) {
          updatedVersion = docSnapshot.data().version + 1;
        }
        const newHistoryObj = {
          name: slcDialog.dev_id,
          enabled: true,
          on_time: {
            hrs: scheduleData.slot_times[0].on_time.hrs,
            mins: scheduleData.slot_times[0].on_time.mins,
          },
          off_time: {
            hrs: scheduleData.slot_times[0].off_time.hrs,
            mins: scheduleData.slot_times[0].off_time.mins,
          },
          slot_times: scheduleData.slot_times,
          ch_dt: new Date(),
          version: updatedVersion,
        };
        await setDoc(newDocRef, newHistoryObj).then(() => {
          updateSlcData(slcDialog.docId, 'sc_upd', true);
          scheduleTim(newHistoryObj)
          setEditScheduledTime(newHistoryObj);
          setScheduleDocId(newDocRef.id);
          addDoc(collection(db(), "schedule_history"), {
            ...newHistoryObj, user: user,
          })
          setHistoryDialog(false);
          setConfirmDialog(false)
          setEnableStatus(true)
          NotificationManager.success("Schedule saved successfully", "", 3000);
        }).catch(() => {
          NotificationManager.error("Failed to save Schedule", "", 3000);
        });
      }
    } else {
      NotificationManager.error("Serial Number is need to create schedule", "", 3000);
    }
  };

  const getSaveDisabledStatus = () => {
    if (editScheduledTime) {
      const { off_time, on_time } = editScheduledTime;
      const currentDate = new Date();
      const startTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        on_time.hrs,
        on_time.mins
      );
      const endTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        off_time.hrs,
        off_time.mins
      );
      return (
        isEqual(selectedStartTimeDate, startTimeDate) &&
        isEqual(selectedEndTimeDate, endTimeDate)
      );
    }
    return false;
  };

  const handleColse = () => {
    if (!getSaveDisabledStatus()) {
      setConfirmDialog(true);
      return
    }
    scheduleTimeSet(editScheduledTime)
    setEditDialog(false);
  };

  const handleFilterApply = async () => {
    const { zone, ward, slcCcms, ilmCcms, status } = localFilter.current;

    DeviceDataService.getInstance().setPageIndex(1);
    setPage(1);

    if (activeTab === '1') {
      await DeviceDataService.getInstance().setDeviceFilter(zone, ward, slcCcms, status);
      DeviceDataService.getInstance().setPageFilter(zone, ward, slcCcms, status);
      await UpdateSlcTable();
    } else {
      // ─── FIX: Reset lamp page on filter apply ────────────────────────────
      setLampPage(1);
      LampDataService.getInstance().setPageIndex(1);
      // ─────────────────────────────────────────────────────────────────────
      await LampDataService.getInstance().setLampFilter(zone, ward, ilmCcms, status);
      await UpdateLampTable();
    }
  };

  async function onFetchComplete() {
    console.log(`========= SLCLiveFeed : onFetchComplete()`);
    if (_liveMeterMounted) UpdateSlcTable();
  }

  async function UpdateSlcTable() {
    if (!_liveMeterMounted) return;
    console.log(`===> LiveMeterFeed - UpdateSLCTable() : Init`);

    const { zone, ward, slcCcms: ccms, status } = localFilter.current;
    const pageNumber = DeviceDataService.getInstance().getPageIndex();
    const pageSz = DeviceDataService.getInstance().getPageSize();

    const {
      deviceList = [],
      allDeviceList = [],
      totalRecords = 0,
    } = await DeviceDataService.getInstance().getPagedDevicesByExplicitFilter(
      zone, ward, ccms, status, pageNumber, pageSz
    );

    if (!_liveMeterMounted) return;

    setOpReportData(deviceList);
    setTotalOpReportData(allDeviceList);
    setTotalRows(totalRecords);

    const deviceListIds = await DeviceDataService.getInstance()
      .getDeviceUidListByZoneWard(zone, ward);

    setSlcCcmsFilterList(deviceListIds);
    setCcmsFilterList(deviceListIds);

    setFilterObj((prevState) => ({
      ...prevState,
      ward,
      zone,
      ccms,
    }));
  }

  // ─── FIX: UpdateLampTable correctly separates page vs totalRecords ────────
  async function UpdateLampTable() {
    if (!_liveMeterMounted) return;
    console.log(`===> LiveMeterFeed - UpdateLampTable() : Init`);

    const { zone, ward, ilmCcms, status } = localFilter.current;
    const pageNumber = LampDataService.getInstance().getPageIndex();
    const pageSz = LampDataService.getInstance().getPageSize();

    const {
      deviceListIds: lampDeviceListIds = [],
      deviceList: lampDeviceList = [],
      allDeviceList = [],
      totalRecords = 0,
    } = await LampDataService.getInstance().getPagedLampsByFilter(
      zone, ward, ilmCcms, status, pageNumber, pageSz
    );

    if (!_liveMeterMounted) return;

    setLampReportData(lampDeviceList);
    setLampReportDataPaged(allDeviceList);

    // ─── FIX: Set totalRecords separately — never confuse it with page index
    setLampTotalRecords(totalRecords);
    // ─────────────────────────────────────────────────────────────────────────

    if (lampDeviceListIds.length > 0) {
      setIlmCcmsFilterList(lampDeviceListIds);
    }
  }
  // ─────────────────────────────────────────────────────────────────────────

  function iterateDeviceHandler(record, changeType, deviceData, allDeviceData) {
    if (!_liveMeterMounted) return;
    var pageNum = DeviceDataService.getInstance().getPageIndex();
    if (record !== null | undefined) {
      if (changeType === "added") {
        UpdateSlcTable();
      } else if (changeType === "modified") {
        console.log(record.dev_id)
        setOpReportData((prevData) => {
          let mapRawData = [...prevData];
          const index = mapRawData.findIndex(item => item.dev_id === record.dev_id);
          if (index !== -1) {
            mapRawData[index] = record;
            return mapRawData;
          }
          return prevData;
        });

        setTotalOpReportData((prevTotal) => {
          let totalRawData = [...prevTotal];
          const index = totalRawData.findIndex(item => item.dev_id === record.dev_id);
          if (index !== -1) {
            totalRawData[index] = record;
            return totalRawData;
          }
          return prevTotal;
        });
      } else if (changeType === "removed") {
        DeviceDataService.getInstance().setPageSize(10)
        DeviceDataService.getInstance().setPageIndex(1)
        UpdateSlcTable();
      }
    }
  }

  async function onLampFetchComplete() {
    if (!_liveMeterMounted) return;
    console.log(`========= LampLiveFeed : onFetchComplete()`);
    await UpdateLampTable();
  }

  const getPoleNumber = (pid) => {
    var polenumber = PoleDataService.getInstance().getPole(pid);
    if (polenumber == null) return "N/A";
    return polenumber.pnum || 'N/A';
  }
  const getPoleWD = (pid) => {
    var polenumber = PoleDataService.getInstance().getPole(pid);
    if (polenumber == null) return "N/A";
    return polenumber.polwd || 'N/A';
  }
  const getPoleAddress = (pid) => {
    var polenumber = PoleDataService.getInstance().getPole(pid);
    if (polenumber == null) return "N/A";
    return polenumber.addr || 'N/A';
  }

  function iterateLampDeviceHandler(record, changeType, lampData, allLampData) {
    if (!_liveMeterMounted) return;
    if (record !== null || record !== undefined) {
      if (changeType === "added") {
        UpdateLampTable();
      } else if (changeType === "modified") {
        setLampReportData((prevData) => {
          let mapRawData = [...prevData];
          const index = mapRawData.findIndex(item => item.dev_id === record.dev_id);
          if (index !== -1) {
            mapRawData[index] = record;
            return mapRawData;
          }
          return prevData;
        });

        setLampReportDataPaged((prevTotal) => {
          let totalRawData = [...prevTotal];
          const index = totalRawData.findIndex(item => item.dev_id === record.dev_id);
          if (index !== -1) {
            totalRawData[index] = record;
            return totalRawData;
          }
          return prevTotal;
        });
      } else if (changeType === "removed") {
        LampDataService.getInstance().setPageSize(10)
        LampDataService.getInstance().setPageIndex(1)
        UpdateLampTable();
      }
    }
  }

  const zoneFilter = pendingFilter.zone;
  const wardFilter = pendingFilter.ward;
  const ccmsFilter = activeTab === '1' ? pendingFilter.slcCcms : pendingFilter.ilmCcms;
  const statusFilter = pendingFilter.status;
  const activeCcmsFilterList = activeTab === '1' ? slcCcmsFilterList : ilmCcmsFilterList;

  const columns = [
    {
      id: 'uid', header: 'UID', accessorKey: 'dev_id',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.dev_id || ''
    },
    {
      id: 'ntw_status', header: 'NTW.STATUS',
      cell: (row) => {
        const ntwStatus = row.row.original.ss || 0;
        const imgs = [Signal0, Signal1, Signal2, Signal3, Signal4];
        return <img src={imgs[Math.min(ntwStatus, 4)]} alt={`Signal ${ntwStatus}`} />;
      },
      exportTransformer: (row) => {
        const map = { 0: 'No Signal', 1: 'Low (1)', 2: 'Medium (2)', 3: 'Good (3)', 4: 'Best (4)' };
        return map[Math.min(row.original.ss || 0, 4)];
      },
    },
    {
      id: 'last_seen', header: 'LAST SEEN',
      cell: (row) => {
        let v = row.row.original.ls;
        if (v?.seconds != null && v?.nanoseconds != null) {
          return format(new Date(v.seconds * 1000 + v.nanoseconds / 1000000), "dd/MM/yyyy, hh:mm a");
        }
        return "";
      },
      exportTransformer: (row) => {
        let v = row.original.ls;
        if (v?.seconds != null && v?.nanoseconds != null) {
          return format(new Date(v.seconds * 1000 + v.nanoseconds / 1000000), "dd/MM/yyyy, hh:mm a");
        }
        return "";
      }
    },
    {
      id: 'zone', header: 'ZONE', accessorKey: 'zn',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.zn || ''
    },
    {
      id: 'ward', header: 'WARD', accessorKey: 'wd',
      Cell: ({ value }) => value || '',
      exportTransformer: (row) => row.original.wd || ''
    },
    {
      id: 'location', header: 'LOCATION',
      cell: (row) => PoleDataService.getInstance().getPole(row.row.original?.pid)?.addr || 'N/A',
      exportTransformer: (row) => PoleDataService.getInstance().getPole(row.original?.pid)?.addr || 'N/A'
    },
    {
      id: 'status', header: 'STATUS',
      cell: (row) => (
        <div style={{ color: row.row.original.dev_st === 1 ? '#1EAC24' : '#EC3434' }}>
          {deviceStatusCode[row.row.original.dev_st]}
        </div>
      ),
      exportTransformer: (row) => deviceStatusCode[row.original.dev_st],
    },
    {
      id: 'errors', header: 'ERRORS',
      cell: (row) => {
        const r = row.row.original.errors?.map(i => deviceErrorEventCode[i] || '') || [];
        return Array.isArray(r) ? r.join(', ') : r;
      },
      exportTransformer: (row) => {
        const r = row.original.errors?.map(i => deviceErrorEventCode[i] || '') || [];
        return Array.isArray(r) ? r.join(', ') : r;
      }
    },
    {
      id: 'mode', header: 'MODE', accessorKey: 'dev_md',
      cell: (row) => deviceModeCode[row.row.original.dev_md || 0],
      exportTransformer: (row) => deviceModeCode[row.original.dev_md || 0],
    },
    {
      id: 'voltage', header: 'VOLTAGE',
      cell: (row) => {
        let rd = row.row.original;
        if (rd.ph_cnt === 3) {
          const [{ vt: r = 0 } = {}, { vt: y = 0 } = {}, { vt: b = 0 } = {}] = rd.data?.ph_data || [];
          return <><Fragment>R: {format2Decimals(r)}</Fragment><br /><Fragment>Y: {format2Decimals(y)}</Fragment><br /><Fragment>B: {format2Decimals(b)}</Fragment></>;
        }
        const [{ vt: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      },
      exportTransformer: (row) => {
        let rd = row.original;
        if (rd.ph_cnt === 3) {
          const [{ vt: r = 0 } = {}, { vt: y = 0 } = {}, { vt: b = 0 } = {}] = rd.data?.ph_data || [];
          return `R: ${r} Y: ${y} B: ${b}`;
        }
        const [{ vt: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      }
    },
    {
      id: 'current', header: 'CURRENT',
      cell: (row) => {
        let rd = row.row.original;
        if (rd.ph_cnt === 3) {
          const [{ cu: r = 0 } = {}, { cu: y = 0 } = {}, { cu: b = 0 } = {}] = rd.data?.ph_data || [];
          return <><Fragment>R: {format2Decimals(r)}</Fragment><br /><Fragment>Y: {format2Decimals(y)}</Fragment><br /><Fragment>B: {format2Decimals(b)}</Fragment></>;
        }
        const [{ cu: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      },
      exportTransformer: (row) => {
        let rd = row.original;
        if (rd.ph_cnt === 3) {
          const [{ cu: r = 0 } = {}, { cu: y = 0 } = {}, { cu: b = 0 } = {}] = rd.data?.ph_data || [];
          return `R: ${r} Y: ${y} B: ${b}`;
        }
        const [{ cu: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      },
    },
    {
      id: 'power_factor', header: 'POWER FACTOR',
      cell: (row) => {
        let rd = row.row.original;
        if (rd.ph_cnt === 3) {
          const [{ pf: r = 0 } = {}, { pf: y = 0 } = {}, { pf: b = 0 } = {}] = rd.data?.ph_data || [];
          return <><Fragment>R: {format2Decimals(r)}</Fragment><br /><Fragment>Y: {format2Decimals(y)}</Fragment><br /><Fragment>B: {format2Decimals(b)}</Fragment></>;
        }
        const [{ pf: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      },
      exportTransformer: (row) => {
        let rd = row.original;
        if (rd.ph_cnt === 3) {
          const [{ pf: r = 0 } = {}, { pf: y = 0 } = {}, { pf: b = 0 } = {}] = rd.data?.ph_data || [];
          return `R: ${r} Y: ${y} B: ${b}`;
        }
        const [{ pf: r = 0 } = {}] = rd.data?.ph_data || [];
        return `R: ${format2Decimals(r)}`;
      },
    },
    {
      id: 'kw', header: 'KW', accessorKey: 'kw',
      cell: (info) => info.getValue() ?? '',
      exportTransformer: (row) => row.original?.kw ?? ''
    },
  ];

  const fullColumn = [
    ...columns,
    {
      id: 'tot_kw', header: 'TOT KW',
      accessorFn: (row) => row?.data?.tot_kw,
      cell: (info) => info.getValue() ?? '',
      exportTransformer: (row) => row.original?.data?.tot_kw ?? ''
    }
  ];

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(opReportData);
  }, [opReportData]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = opTotalReportData.filter((row) =>
        String(row.dev_id).toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
      setPage(1);
    } else {
      setFilteredData(opReportData);
    }
  }, [searchQuery, opTotalReportData]);

  const currentPageData = searchQuery
    ? filteredData.slice((page - 1) * pageSize, page * pageSize)
    : filteredData;

  const pageCount = searchQuery
    ? Math.ceil(filteredData.length / pageSize)
    : Math.ceil(totalRows / pageSize);

  const table = useReactTable({
    data: currentPageData,
    columns,
    pageCount,
    manualPagination: true,
    state: {
      pagination: {
        pageIndex: page - 1,
        pageSize,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    onPaginationChange: (updater) => {
      const newPagination =
        typeof updater === 'function'
          ? updater({ pageIndex: page - 1, pageSize })
          : updater;

      const newPage = newPagination.pageIndex + 1;
      setPage(newPage);

      if (!searchQuery) {
        DeviceDataService.getInstance().setPageIndex(newPage);
        UpdateSlcTable();
      }
    },
  });

  const fullTable = useReactTable({
    data: opTotalReportData,
    columns: fullColumn,
    getCoreRowModel: getCoreRowModel(),
  });

  const scheduleTim = (scheduleInfo) => {
    const { off_time: { mins: offMins = 0, hrs: offHrs }, on_time: { mins: onMins = 0, hrs: onHrs } } = scheduleInfo;
    const offTime = new Date();
    offTime.setHours(offHrs);
    offTime.setMinutes(offMins);
    const onTime = new Date();
    onTime.setHours(onHrs);
    onTime.setMinutes(onMins);
    setScheduleTime(`${formatTime(onTime)} - ${formatTime(offTime)}`)
  }

  useEffect(async () => {
    await getScheduleInfo(slcDialog?.dev_id)
      .then(({ docId, scheduleInfo }) => {
        setScheduleDocId(docId);
        if (scheduleInfo) {
          setEditScheduledTime(scheduleInfo);
          scheduleTim(scheduleInfo)
          if (scheduleInfo.enabled != undefined) {
            setEnableStatus(scheduleInfo.enabled)
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [slcDialog]);

  const downloadFile = (tbl, fmt) => {
    onClose();
    const headers = tbl.getHeaderGroups()[0].headers.map(column => column.id.toLocaleUpperCase());
    const rows = tbl.getRowModel().rows.map(row => {
      return row.getVisibleCells().map(cell => {
        const column = tbl.getColumn(cell.column.id);
        const transformedValue = column.columnDef.exportTransformer
          ? column.columnDef.exportTransformer(row)
          : String(cell.getValue());
        return transformedValue;
      });
    });

    if (fmt === 'excel') {
      const ws_data = [headers, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const dataBlob = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(dataBlob, `LampLiveFeed-${new Date().toLocaleDateString()}.xlsx`);
    } else if (fmt === 'pdf') {
      const doc = new jsPDF({
        orientation: 'l',
        unit: 'in',
        format: [8, 18],
      });
      autoTable(doc, { head: [headers], body: rows });
      doc.save(`Live Meter Report-${getDateString()}.pdf`);
    } else {
      console.error('Unsupported format: ' + fmt);
    }
  };

  const onClose = () => {
    setAnchor(null);
    setExportAction(null);
  }

  const handleSearchChange = (event) => {
    table.firstPage();
    setSearchQuery(event.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const filteredRows = table.getRowModel().rows.filter((row) => {
    const uidCell = row.getVisibleCells().find((cell) => cell.column.id === 'uid');
    return uidCell && String(uidCell.getValue()).toLowerCase().includes(searchQuery.toLowerCase().trim());
  });

  const [anchor, setAnchor] = React.useState(null);
  const [exportAction, setExportAction] = React.useState(null);

  const handleExport = async (event, data) => {
    setAnchor(event.currentTarget);
    setExportAction(data ?? false);
  }

  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutes} ${ampm}`;
  };

  // ─── FIX: onChangeLampPage updates lampPage state AND service page index ──
  const onChangeLampPage = async (event, pageNumber) => {
    setLampPage(pageNumber);
    LampDataService.getInstance().setPageIndex(pageNumber);
    await UpdateLampTable();
  }
  // ─────────────────────────────────────────────────────────────────────────

  let editAction = checkUserAccess("schedule");

  const ButtonContainer = (data) => {
    const [relayOn, setRelayOn] = useState(data?.relay_on === true || data?.relay_on === false ? data.relay_on : null);
    const [slcLog, setSlcLog] = useState(data?.slc_log);
    const [getSt, setGetSt] = useState(data?.get_st);
    const [getGpio, setGetGpio] = useState(data?.get_gpio);
    const [schCheck, setSchCheck] = useState(data?.sch_check);
    const [rbtRpi, setRbtRpi] = useState(data?.rbt_rpi);

    useEffect(() => {
      setRelayOn(data?.relay_on);
      setSlcLog(data?.slc_log);
      setGetSt(data?.get_st);
      setGetGpio(data?.get_gpio);
      setSchCheck(data?.sch_check);
      setRbtRpi(data?.rbt_rpi);
    }, [data]);

    const handleOnClickBtn = (value, newState) => {
      updateSlcData(slcDialog.docId, value, newState).then(() => {
        switch (value) {
          case 'relay_on': setRelayOn(newState); break;
          case 'slc_log': setSlcLog(newState); break;
          case 'get_st': setGetSt(newState); break;
          case 'get_gpio': setGetGpio(newState); break;
          case 'sch_check': setSchCheck(newState); break;
          case 'rbt_rpi': setRbtRpi(newState); break;
          default: break;
        }
      });
    };

    const renderButton = (label, action, currentState) => (
      <button onClick={() => handleOnClickBtn(action, !currentState)} className={`toggle-btn ${currentState ? 'on' : 'off'}`}>
        {label}: {currentState ? "On" : "Off"}
      </button>
    );

    const rendButton = (label, action, currentState) => {
      if (true === currentState) {
        return <button onClick={() => handleOnClickBtn(action, false)} className="toggle-btn on">{label}</button>;
      } else if (false === currentState) {
        return <button onClick={() => handleOnClickBtn(action, true)} className="toggle-btn off">{label}</button>;
      } else {
        return <button onClick={() => handleOnClickBtn(action, label === "Relay Off" ? false : true)} className="toggle-btn off">{label}</button>;
      }
    };

    return (
      <div className="button-container">
        <div className="button-row1">
          {rendButton("Relay On", "relay_on", relayOn === true ? true : null)}
          {rendButton("Relay Off", "relay_on", relayOn === false ? false : null)}
          {renderButton("Log", "slc_log", slcLog)}
        </div>
        <div className="button-row1">
          {renderButton("Sync Status", "get_st", getSt)}
          {renderButton("Get GPIO", "get_gpio", getGpio)}
          {renderButton("Schedule Check", "sch_check", schCheck)}
        </div>
        <div className="button-row2">
          {renderButton("Reboot", "rbt_rpi", rbtRpi)}
        </div>
      </div>
    );
  };

  const getLatLng = (rowData) => {
    let degreeSymbol = "\u00B0";
    let result = "";
    let latitude = 0;
    let longitude = 0;
    let pole = null;
    if (rowData?.pid != undefined && rowData?.pid != null) {
      pole = PoleDataService.getInstance().getPole(rowData?.pid);
    }
    if (pole != null && pole?.loc != undefined && pole?.loc != null) {
      const { loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {} } = pole;
      latitude = latitudeVal; longitude = longitudeVal;
    } else if (rowData?.lloc != undefined) {
      const { lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {} } = rowData;
      latitude = latitudeVal; longitude = longitudeVal;
    } else {
      const { loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {} } = rowData;
      latitude = latitudeVal; longitude = longitudeVal;
    }
    if ((latitude === undefined | "") || (longitude === undefined | "")) return "N/A";
    result = latitude > 0 ? `${latitude.toFixed(4)}${degreeSymbol}N` : `${latitude.toFixed(4)}${degreeSymbol}S`;
    result = longitude > 0 ? `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]` : `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
    return result;
  }

  return (
    <div className="reports">
      <h2 className="reports-header">Live Meter Feed</h2>
      <Grid container className="reports-filter-wrapper">
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
            {/* Zone */}
            <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select labelId="zone-label" id="zone-outlined" name="zone" value={zoneFilter} onChange={handleFilterChange} label="Zone">
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Ward */}
            <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select labelId="ward-label" id="ward-outlined" name="ward" value={wardFilter} onChange={handleFilterChange} label="Ward">
                {wardFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* UID */}
            <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="ccms-label">UID</InputLabel>
              <Select
                labelId="ccms-label"
                id="ccms-outlined"
                name="ccms"
                value={
                  activeCcmsFilterList.some(item => item.value === ccmsFilter)
                    ? ccmsFilter
                    : 0
                }
                onChange={handleFilterChange}
                label="UID"
              >
                {activeCcmsFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Status */}
            <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="status-label">STATUS</InputLabel>
              <Select labelId="status-label" id="status-outlined" name="status" value={statusFilter} onChange={handleFilterChange} label="STATUS">
                {statusFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button variant="contained" className="ml-auto reports-apply-btn" onClick={handleFilterApply}>
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={activeTab} classes={{ root: classes.tab }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="live meter feed" indicatorColor='primary'>
              <Tab label="SLC" value="1" />
              <Tab label="ILM" value="2" />
            </TabList>
          </Box>

          {/* ── SLC Tab ── */}
          <TabPanel value="1" style={{ padding: '0px' }}>
            <div style={{ margin: '20px 0', width: '100%', backgroundColor: '#fff', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)', borderRadius: '5px' }}>
              <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff', padding: '10px', borderBottom: '1px solid #ddd', justifyContent: 'flex-end', marginBottom: -20, paddingRight: '20px', borderRadius: '5px' }}>
                <div style={{ borderBottom: '1px solid #666666' }}>
                  <SearchIcon style={{ marginBottom: '-4px', fontSize: '18px', color: '#000000' }} />
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ padding: '8px', fontSize: '1em', borderRadius: '0', border: 'none', borderBottom: '2px solid #FFFFFF', width: '200px', marginRight: '10px', outline: 'none' }}
                  />
                  <CloseIcon
                    style={{ fontSize: '18px', color: searchQuery ? '#5e5e5e' : '#8c8c8c', cursor: searchQuery ? 'pointer' : 'default', marginRight: '10px', marginBottom: '-5px' }}
                    onClick={searchQuery ? clearSearch : null}
                  />
                </div>
                <FiDownload
                  style={{ fontSize: '20px', color: '#666666', marginLeft: '10px', cursor: 'pointer' }}
                  onClick={(event) => handleExport(event, true)}
                />
              </div>

              <Menu id="long-menu" anchorEl={anchor} keepMounted open={exportAction} onClose={onClose}>
                <MenuItem onClick={() => downloadFile(fullTable, "excel")}>Export as Excel</MenuItem>
                <MenuItem onClick={() => downloadFile(fullTable, "pdf")}>Export as PDF</MenuItem>
              </Menu>

              <div style={{ overflowX: 'auto', overflowY: 'hidden' }}>
                <table style={{ margin: '20px 0px 0 0', width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                      <tr key={headerGroup.id} style={{ backgroundColor: '#0071CE', color: '#FFF', textAlign: 'center' }}>
                        {headerGroup.headers.map((column) => (
                          <th colSpan={column.colSpan} key={column.id} style={{ padding: '25px', fontSize: '0.9em' }}>
                            {flexRender(column.column.columnDef.header, column.getContext())}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {filteredRows.length > 0 ? (
                      filteredRows.map((row) => (
                        <tr
                          onClick={async () => {
                            var lampCnt = await LampDataService.getInstance().getLampsBySLC(row.original?.uid);
                            setLampCount(lampCnt.deviceList.length);
                            setILMCount(lampCnt.ilmDeviceList.length);
                            setSlcDialog(row.original);
                          }}
                          key={row.id}
                          style={{ cursor: 'pointer' }}
                        >
                          {row.getVisibleCells().map((cell) => (
                            <td style={{ padding: '20px', border: '0px solid #ddd' }} key={cell.id}>
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center', padding: '20px' }}>
                          No records to display
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* SLC Pagination */}
              <Button onClick={() => { setPage(1); table.setPageIndex(0); if (!searchQuery) { DeviceDataService.getInstance().setPageIndex(1); UpdateSlcTable(); } }} disabled={page === 1}>
                <KeyboardDoubleArrowLeftIcon />
              </Button>
              <Button onClick={() => { if (page > 1) { const n = page - 1; setPage(n); table.setPageIndex(n - 1); if (!searchQuery) { DeviceDataService.getInstance().setPageIndex(n); UpdateSlcTable(); } } }} disabled={page === 1}>
                <KeyboardArrowLeftIcon />
              </Button>
              <span>Page {page} of {pageCount}</span>
              <Button onClick={() => { if (page < pageCount) { const n = page + 1; setPage(n); table.setPageIndex(n - 1); if (!searchQuery) { DeviceDataService.getInstance().setPageIndex(n); UpdateSlcTable(); } } }} disabled={page >= pageCount}>
                <KeyboardArrowRightIcon />
              </Button>
              <Button onClick={() => { setPage(pageCount); table.setPageIndex(pageCount - 1); if (!searchQuery) { DeviceDataService.getInstance().setPageIndex(pageCount); UpdateSlcTable(); } }} disabled={page >= pageCount}>
                <KeyboardDoubleArrowRightIcon />
              </Button>

              <select
                style={{ padding: '8px', minWidth: '100px' }}
                value={table.getState().pagination.pageSize}
                onChange={e => {
                  const newSize = Number(e.target.value);
                  table.setPageSize(newSize);
                  table.setPageIndex(0);
                  DeviceDataService.getInstance().setPageIndex(1);
                  DeviceDataService.getInstance().setPageSize(newSize);
                  setPageSize(newSize);
                }}
              >
                {[10, 20, 30, 40, 50].map(ps => <option key={ps} value={ps}>{ps}</option>)}
              </select>
            </div>
          </TabPanel>

          {/* ── ILM Tab ── */}
          {/*
            ─── FIX: Pass lampPage (current page number) and lampTotalRecords
                (total record count) as separate props so LampLiveFeed can
                correctly compute pageCount and render pagination buttons.
                Previously, both were mashed into a single `page` prop set to
                `totalRecords`, which meant pageCount was always 1 (or NaN)
                and every Next/Prev button was disabled.
          ─── */}
          <TabPanel value="2" style={{ padding: '0px' }}>
            <LampLiveFeed
              filter={DeviceDataService.getInstance().getDeviceFilter()}
              ilmUid={pendingFilter.ilmCcms}
              devices={lampReportData}
              devicePaged={lampReportDataPaged}
              page={lampPage}
              totalRecords={lampTotalRecords}
              onChangePage={onChangeLampPage}
              onUpdate={UpdateLampTable}
            />
          </TabPanel>
        </TabContext>
      </Box>

      {/* ── Change Schedule Dialog ── */}
      <Dialog className="change-schedule-dialog" onClose={handleColse} aria-labelledby="editTime-dialog-title" open={editDialog} fullWidth>
        <DialogTitle id="editTime-dialog-title" onClose={handleColse}>
          {enableStatus ? "Change" : "Create"} Individual Schedule
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleColse}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="change-schedule-wrapper">
            <div style={{ marginRight: "10%" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker autoOk label="Start Time" value={selectedStartTimeDate} onChange={(date) => handleChangeSLCSchedulDate(date, "start")} />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker autoOk label="End Time" value={selectedEndTimeDate} onChange={(date) => handleChangeSLCSchedulDate(date, "end")} />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="save-btn" onClick={OnClickSaveSchedule} disabled={getSaveDisabledStatus()}>Save</Button>
          <Button className="save-btn" onClick={handleColse}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* ── Confirm Dialog ── */}
      <Dialog className="change-schedule-dialog" onClose={() => { scheduleTimeSet(editScheduledTime); setConfirmDialog(false); setEditDialog(false); }} aria-labelledby="edit-schedule-dialog-title" open={confirmDialog} fullWidth>
        <DialogTitle id="edit-schedule-dialog-title" onClose={() => { scheduleTimeSet(editScheduledTime); setConfirmDialog(false); setEditDialog(false); }}>
          Confirm Schedule Update
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => { scheduleTimeSet(editScheduledTime); setConfirmDialog(false); setEditDialog(false); }}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">Do you want to save the changes?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="save-btn" onClick={OnClickSaveSchedule} color="primary">Save</Button>
          <Button className="cancel-btn" onClick={() => { scheduleTimeSet(editScheduledTime); setConfirmDialog(false); setEditDialog(false); }} color="secondary">Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* ── SLC Information Dialog ── */}
      <Dialog className="history-dialog" open={slcDialog != null} onClose={hideSlcInfoDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth="lg">
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', marginBottom: '20px', marginTop: '20px', color: '#333', paddingLeft: '20px' }}>
                SLC Information
                <IconButton aria-label="close" className={classes.closeButton} onClick={hideSlcInfoDialog}><CloseIcon /></IconButton>
              </Typography>
              <div style={{ marginBottom: '15px', padding: '20px' }}>
                {isAPILoading && <CircularProgress className="circular-progress-center" disableShrink />}
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="body2" className="typography-root"><strong>UID:</strong> <span className="typography-value">{slcDialog?.dev_id || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>OS Version:</strong> <span className="typography-value">{slcDialog?.os_ver || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>RF Version:</strong> <span className="typography-value">{slcDialog?.rf_ver || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Switch Number:</strong> <span className="typography-value">{slcDialog?.sw_no || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Phase Count:</strong> <span className="typography-value">{slcDialog?.ph_cnt || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Pole Number:</strong> <span className="typography-value">{slcDialog?.pid ? getPoleNumber(slcDialog?.pid) : "N/A"}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Total Poles:</strong> <span className="typography-value">{slcDialog?.tpoles > 0 ? slcDialog?.tpoles : 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Service Conn No:</strong> <span className="typography-value">{slcDialog?.sc_no || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Total kW Before Conversion:</strong> <span className="typography-value">{slcDialog?.tot_kw || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Total kW after Conversion:</strong> <span className="typography-value">{slcDialog?.kw || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Zone:</strong> <span className="typography-value">{slcDialog?.zn || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Ward:</strong> <span className="typography-value">{slcDialog?.wd || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Pole Ward:</strong> <span className="typography-value">{slcDialog?.pid ? getPoleWD(slcDialog?.pid) : "N/A"}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Location:</strong> <span className="typography-value">{slcDialog?.pid ? getPoleAddress(slcDialog?.pid) : "N/A"}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>GPS Location:</strong> <span className="typography-value">{slcDialog ? getLatLng(slcDialog) : "N/A"}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>EB Box:</strong> <span className="typography-value">{slcDialog?.eb_box ? 'Yes' : 'No'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>SIM Number:</strong> <span className="typography-value">{slcDialog?.sim_no || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Last Changed:</strong> <span className="typography-value">{slcDialog?.mdt ? new Date((slcDialog?.mdt?.seconds * 1000) + slcDialog?.mdt?.nanoseconds / 1000000).toLocaleString() : "N/A"}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Internal ID:</strong> <span className="typography-value">{slcDialog?.uid || 'N/A'}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>Lamp Count:</strong> <span className="typography-value">{lampCount}</span></Typography>
                    <Typography variant="body2" className="typography-root"><strong>ILM Count:</strong> <span className="typography-value">{ILMCount}</span></Typography>
                  </Grid>

                  <Grid item xs={8}>
                    {ButtonContainer(slcDialog)}
                    <Typography style={{ marginLeft: '10px' }} variant="body2" className="typography-root">
                      <strong>Status:</strong> <span className="typography-value">{slcDialog?.dev_st === dev_constants.DeviceStatusOn ? 'ON' : deviceStatusCode[2]}</span>
                    </Typography>
                    <Typography variant="body2" className="typography-root" style={{ marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <strong>Schedule Enabled : ({enableStatus ? "Individual" : "Global"})</strong>
                      <div style={{ display: 'flex', alignItems: 'center', marginRight: '100px', height: '30px', width: '30px' }}>
                        {!enableStatus && editAction && (
                          <ToggleOffTwoToneIcon
                            onClick={async () => {
                              getSchedule(slcDialog?.dev_id).then(({ docId, scheduleInfo }) => {
                                setScheduleDocId(docId);
                                if (scheduleInfo.name !== "default") {
                                  setEnableStatus(true);
                                  updateFlag({ name: slcDialog.dev_id, enabled: true, user: getUserNameEmail('email') }, scheduleInfo);
                                  setEditScheduledTime(scheduleInfo);
                                  scheduleTim(scheduleInfo);
                                } else {
                                  setHistoryDialog(true);
                                }
                              }).catch(console.error);
                            }}
                            style={{ color: "red", width: '30px', height: '30px' }}
                            titleAccess="Off"
                          />
                        )}
                        {enableStatus && editAction && (
                          <ToggleOnTwoToneIcon
                            onClick={async () => {
                              getSchedule("default").then(({ docId, scheduleInfo }) => {
                                setScheduleDocId(docId);
                                if (scheduleInfo) {
                                  setEnableStatus(false);
                                  updateFlag({ name: slcDialog.dev_id, enabled: false, user: getUserNameEmail('email') }, editScheduledTime);
                                  setEditScheduledTime(scheduleInfo);
                                  scheduleTim(scheduleInfo);
                                }
                              }).catch(console.error);
                            }}
                            style={{ color: "green", width: '30px', height: '30px' }}
                            titleAccess="On"
                          />
                        )}
                      </div>
                    </Typography>
                    <Typography style={{ marginLeft: '10px' }} variant="body2" className="typography-root">
                      <strong>Schedule:</strong> <span className="typography-value">{scheduleTime ? scheduleTime : "N/A"}</span>
                      {(enableStatus === true && editAction && scheduleDocId !== "default") &&
                        <EditIcon
                          onClick={() => {
                            getScheduleInfo(slcDialog?.dev_id).then(({ docId, scheduleInfo }) => {
                              setScheduleData(scheduleInfo);
                              setScheduleDataID(docId);
                              setHistoryDialog(true);
                            }).catch(console.error);
                          }}
                          style={{ marginLeft: "10px", marginBottom: '-7px' }}
                          titleAccess="Edit"
                        />}
                      {<HistoryIcon
                        onClick={async () => {
                          setScheduleHistoryOpen(true);
                          await getScheduleHistoryAPICall(slcDialog?.dev_id || "").then((formattedHistory) => {
                            setScheduleHistoryData(formattedHistory);
                          }).catch((e) => { NotificationManager.error(e, "", 3000); });
                        }}
                        style={{ marginLeft: "10px", marginBottom: '-7px' }}
                        titleAccess="History"
                      />}
                    </Typography>
                    {slcDialog ? <SlcMap data={slcDialog} /> : null}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions />
      </Dialog>

      {/* ── Schedule History Dialog ── */}
      <Dialog className="history-dialog" open={scheduleHistoryOpen} onClose={() => { setScheduleHistoryOpen(false); setScheduleHistoryData([]); }} aria-labelledby="form-dialog-title" fullWidth maxWidth="md">
        <DialogTitle id="form-dialog-title">Individual Schedule History</DialogTitle>
        <DialogContent>
          <MaterialTable
            style={{ width: "100%" }}
            className={classes.table}
            title=""
            columns={getScheduleHistoryColumnList()}
            data={scheduleHistoryData}
            options={{ exportButton: false, search: false, selection: false, sorting: true, pageSize: 5, headerStyle: { backgroundColor: "#0071CE", color: "#FFF", fontSize: "0.9em", textAlign: "center" }, actionsColumnIndex: -1, emptyRowsWhenPaging: false }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setScheduleHistoryOpen(false); setScheduleHistoryData([]); }} color="primary">CLOSE</Button>
        </DialogActions>
      </Dialog>

      {/* ── Add/Edit Dim Schedule Dialog ── */}
      <Dialog className="change-schedule-dialog" onClose={OnClickCancelDimSchedule} aria-labelledby="editTime-dialog-title" open={dimScheduleDialog.view !== ''} fullWidth>
        <DialogTitle id="editTime-dialog-title" onClose={OnClickCancelDimSchedule}>
          {dimScheduleDialog.view === 'add' ? "Add" : "Edit"} Dim Schedule
          <IconButton aria-label="close" className={classes.closeButton} onClick={OnClickCancelDimSchedule}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="change-schedule-wrapper">
            <div style={{ marginRight: "10%" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker autoOk label="Start Time" value={dimScheduleDialog.start} onChange={(date) => handleSelectedDate(date, "dim-start")} />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker autoOk label="End Time" value={dimScheduleDialog.end} onChange={(date) => handleSelectedDate(date, "dim-end")} />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="save-btn" onClick={OnClickUpdateDimSchedule}>Save</Button>
          <Button className="save-btn" onClick={OnClickCancelDimSchedule}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* ── Dim Schedule Display Dialog ── */}
      <Dialog className="history-dialog" open={historyDialog} onClose={scheduleDialogClose} aria-labelledby="form-dialog-title" fullWidth maxWidth="md">
        <DialogContent>
          <Schedule
            schedule={scheduleData}
            enableStatus={enableStatus}
            isUpdated={null}
            OnClickAddSchedule={OnClickAddSchedule}
            OnClickEditSchedule={OnClickEditSchedule}
            OnClickDeleteSchedule={OnClickDeleteSchedule}
            OnClickSaveSchedule={OnClickSaveSchedule}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={scheduleDialogClose} color="primary">CLOSE</Button>
          <Button onClick={() => { if (onUpdateDimSchedule) { OnClickSaveSchedule(); } else { NotificationManager.error("No changes to save Dim Schedule", "", 3000); } }} color="primary">SAVE</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default LiveMeterFeed;